module.exports = __webpack_public_path__ + "img/packages.101d9d43.png";